export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_q05_b.b088cfc3.png";